// One formatter for the "needs advance prep" badge — every surface that
// shows a recipe card or its detail reads `passive_wait_minutes` through
// this, the same reason MEAL_TYPE_BADGE (utils/mealTypes.js) exists as a
// single copy instead of six.
//
// `passive_wait_minutes` is the longest passive wait (refrigerate/chill/
// marinate/...) found in the recipe's own step prose, derived server-side by
// add_content/passive_wait.py and stored on Recipe.passive_wait_minutes —
// see CLAUDE.md. Deliberately a distinct color from MEAL_TYPE_BADGE and the
// diet chips: this is a planning warning ("start this a day ahead"), not a
// category label, and folding it into the same visual language as "Main" or
// "Vegetarian" would bury the thing it exists to surface.

const PASSIVE_WAIT_STYLE = { color: "#8a4b00", bg: "#fff3e0" };

export function passiveWaitLabel(passiveWaitMinutes) {
  if (!passiveWaitMinutes || passiveWaitMinutes < 60) return null;
  const hours = Math.round(passiveWaitMinutes / 60);
  return `⏳ Needs ${hours}h ahead`;
}

export function passiveWaitBadge(passiveWaitMinutes) {
  const label = passiveWaitLabel(passiveWaitMinutes);
  if (!label) return null;
  return { label, ...PASSIVE_WAIT_STYLE };
}

export default passiveWaitBadge;
